//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Sidebar from './sidebar'
import Header from './header'
import SetLocation from './location'
import AddProductMenu from './productMenu'
import Layout from '@/components/ResponsiveLayout'
import Heading from '@/components/Heading'
import SwoopForm from '@/components/SwoopForm'
import ActionButtons from '@/components/ActionButtons'
import API from '@/api/quotes'
import Fields from './fields'
import { getRelativeDate } from '@/utils/swoop'

const GROUP = process.env.VUE_APP_MODE
const IP_TRANSIT = process.env.VUE_APP_IP_TRANSIT_ID
const IP_TRANSIT_PORT = process.env.VUE_APP_IP_TRANSIT_PORT_ID
const DCI = process.env.VUE_APP_DCI_ID
const NATIONAL = process.env.VUE_APP_NATIONAL_ID
const INTERNATIONAL = process.env.VUE_APP_INTERNATIONAL_ID

export default {
  components: {
    Layout,
    Header,
    Heading,
    AddProductMenu,
    Sidebar,
    SwoopForm,
    ActionButtons,
    SetLocation
  },

  data() {
    return {
      form: null, // API object for the SwoopForm containing quote name. Allows us to access deeper form functionality such as form.isDirty().
      quote: null, // Current quote data
      setLocation: false, // When true, a location confirmation page is displayed (when adding fixed wireless products).
      IP_TRANSIT: IP_TRANSIT,
      IP_TRANSIT_PORT: IP_TRANSIT_PORT,
      DCI: DCI,
      NATIONAL: NATIONAL,
      INTERNATIONAL: INTERNATIONAL
    }
  },

  created() {
    this.$store.dispatch('resetSidebar') // Clears sidebar Vuex data
    this.refreshQuote()
    this.refreshQuoteList()
  },

  watch: {
    $route() {
      // If url changes, refresh quote...
      this.refreshQuote()
    },
    id: {
      handler: function(val) {
        if (typeof val === 'undefined') {
          this.$store.commit('set', ['isSideBarOpen', true])
        } else {
          if (!this.$q.screen.gt.sm) {
            this.$store.commit('set', ['isSideBarOpen', false])
          }
        }
      },
      immediate: true
    },
    sidebarSearch() {
      this.refreshQuoteList()
    }
  },

  computed: {
    id() {
      return this.$route.params.id
    },
    isNew() {
      return this.id === 'new'
    },
    isQuoteNameDirty() {
      return this.form && this.form.isDirty()
    },
    dateCreated() {
      return getRelativeDate(this.quote.created, true)
    },
    sidebarSearch() {
      return this.$store.state.sidebarSearch
    }
  },

  methods: {
    getTopFields() {
      // For a new quote we only display the quote name field
      return this.isNew ? Fields.name() : Fields.top()
    },

    getTotalsFields() {
      return Fields.totals()
    },

    getProductFields(product, idx) {
      if (this.getProductType(product) === 'WIRELESS') {
        return Fields.productWireless(product, idx)
      } else if (this.getProductType(product) === 'IP_TRANSIT') {
        return Fields.productIpTransit(product, idx)
      } else if (this.getProductType(product) === 'IP_TRANSIT_PORT') {
        return Fields.productIpTransitPort(product, idx)
      } else {
        return Fields.productOther(product, idx)
      }
    },

    getProductType(product) {
      // Product type is worked out by checking for the presence of
      // particular product fields. This approach is least likely to
      // break if the Flexile API changes unexpectedly.
      try {
        if (product.fields.address) {
          return 'WIRELESS'
        } else if (product.fields.burstRate) {
          return 'IP_TRANSIT'
        } else if (product.fields.aDCLocation) {
          return 'IP_TRANSIT_PORT'
        } else {
          return 'OTHER'
        }
      } catch (e) {
        return null
      }
    },

    getTransitPorts(product, idx) {
      // When passed a product & index, this will return any subsequent IP Transit Ports.
      // So essentially this returns all the ports for an IP Transit parent product (because the ports
      // always follow the IP Transit parent product in the products array). There is no other way to
      // do this as there is no link between the IP Transit parent and its ports (which are also
      // products in the same array).
      let portProducts = []

      if (this.getProductType(product) === 'IP_TRANSIT') {
        idx++
        while (
          this.getProductType(this.quote.products[idx]) === 'IP_TRANSIT_PORT'
        ) {
          portProducts.push(this.quote.products[idx])
          idx++
        }
      }
      return portProducts
    },

    getPortProductIndex(ipTransitProductIdx, portProductIdx) {
      /* 
        Every SwoopForm product field has to reference the correct product array index. For 
        transit ports we have a nested v-for, but this means that the loop index no longer
        points to the product array index. Instead we have to do the following to get the
        correct product index for a port: 
      */
      return ipTransitProductIdx + portProductIdx + 1
    },

    getTotalPortBandwidth(ipTransitProductIdx) {
      /*
        Totals the max bandwidth of all ports for a specified IP Transit product. As there is no
        link between IP Transit products and transit ports (they are all just products), we total
        up all subsequent products of type IP_TRANSIT_PORT until a different product type (or the
        end of the array) is reached.   
      */
      let totalBandwidth = 0
      let products = this.quote.products
      let i = ipTransitProductIdx + 1
      while (
        i < products.length &&
        this.getProductType(products[i]) === 'IP_TRANSIT_PORT'
      ) {
        totalBandwidth += products[i].input.maxBandwidth || 0
        i++
      }
      return totalBandwidth
    },

    refreshQuote() {
      this.setLocation = false
      if (this.isNew) {
        if (this.form) {
          // If form is already rendered, loads the empty quote into the rendered form,
          // allowing it to correctly track further changes. "true" flag sets focus.
          this.form.load(this.getEmptyQuote(), true)
        }
        this.quote = this.getEmptyQuote()
      } else if (this.id) {
        API.getQuote(this.id)
          .then(quote => {
            if (!quote) {
              this.$store
                .dispatch('confirm', {
                  icon: 'priority_high',
                  text: `QUOTE NOT FOUND`,
                  cancelText: null
                })
                .then(() => {
                  this.$router.push('/quotes')
                })
            } else {
              this.setProductDefaults(quote)
              if (this.form) {
                // If form is already rendered, loads the new quote into the rendered form,
                // allowing it to correctly track further changes.
                this.form.load(quote)
              }
              this.quote = quote
              this.refreshQuoteListItem(quote)
            }
          })
          .catch(error => {
            console.log(error) // eslint-disable-line no-console
            this.$router.push('/quotes')
          })
      }
    },

    refreshQuoteList() {
      API.getQuotes(this.$store.state.sidebarSearch).then(quotes => {
        this.$store.commit('set', ['sidebarRecords', quotes])
      })
    },

    refreshQuoteListItem(quote) {
      // Updates a specific quote in the the list of quotes, or adds it if it does not yet exist.
      // This is a quick way of updating the list after changing a quote (instead of reloading the whole list).
      let quotes = [...this.$store.state.sidebarRecords]
      let quoteIdx = quotes.findIndex(q => q._id === quote._id)
      if (quoteIdx >= 0) {
        if (quote.deleted) {
          quotes.splice(quoteIdx, 1)
        } else {
          quotes[quoteIdx] = quote
        }
      } else {
        quotes.push(quote)
      }
      this.$store.commit('set', ['sidebarRecords', quotes])
    },

    openLocationForm() {
      this.setLocation = true
    },

    addProduct(productId) {
      let newProduct = {
        use: productId,
        group: GROUP,
        lookupGroup: GROUP,
        input: {}
      }
      this.saveProduct(newProduct)
    },

    addPort(product, idx) {
      product.input = {
        dcPortNums: this.getTransitPorts(product, idx).length + 1
      }
      this.saveProduct(null, idx)
    },

    setProductDefaults(quote) {
      // When loading a quote we ensure that all product defaults are copyied into their
      // "input" objects (unless they already have a value). This allows our product fields
      // to display the correct defaults when a new empty product is added to a quote.

      // Clear any null products (might be just a Flexile test data issue, but we're playing it safe for now)
      quote.products = quote.products.filter(
        product => product && typeof product === 'object'
      )

      quote.products.forEach(product => {
        // Ensure the product's input object is present (our product fields bind to this object)...
        if (!product.input || product.input.length === 0) {
          product.input = {}
        }

        // Iterate through Flexile product fields and copy any defaults into the input object...
        Object.keys(product.fields).forEach(field => {
          if (!product.input[field] && product.fields[field].default) {
            product.input[field] = product.fields[field].default
          }
        })
      })
    },

    async saveProduct(newProduct, productIdx) {
      // Only specify newProduct when adding a new product (just specify productIdx for updating)

      // Products cannot be updated. Instead we receive a new "product instance" with a new id.
      // The quote products array must also be updated with this new id.
      this.$store.dispatch('showSpinner', 'Updating...')
      let newProductInstance = await API.postProduct(
        newProduct || this.quote.products[productIdx],
        false
      )
      if (newProduct) {
        this.quote.products.push(newProductInstance)
      } else {
        this.quote.products[productIdx] = newProductInstance
      }
      await this.saveQuote(false)
      this.$store.dispatch('hideSpinner')
    },

    async saveQuote(showSpinner, isClone) {
      if (this.form.focusError()) {
        return // Return if form has validation errors
      }
      try {
        let isNew = isClone || this.isNew
        const response = isNew
          ? await API.createQuote(this.quote, showSpinner)
          : await API.updateQuote(this.quote, showSpinner)

        if (isNew) {
          this.refreshQuoteListItem(response)
          this.$router.push(`/quotes/${response._id}`)
        } else {
          this.refreshQuote()
        }
      } catch (e) {
        //
      }
    },

    async deleteQuote() {
      await this.$store.dispatch('confirm', {
        icon: 'o_delete',
        text: `Delete "${this.quote.name}"?`,
        detail: 'This quote will be permanently removed.',
        okText: 'Delete'
      })
      this.quote.deleted = true
      this.refreshQuoteListItem(this.quote)
      this.saveQuote()
      this.$router.push('/quotes')
    },

    async deleteProduct(product, idx) {
      await this.$store.dispatch('confirm', {
        icon: 'o_delete',
        text: `Remove "${product.fields.description.value}"?`,
        detail: 'This item will be permanently removed from the quote.',
        okText: 'Remove'
      })

      // Builds new products array without deleted product and without
      // any IP transit ports belonging to the deleted product.
      let newProducts = []
      let deleteSubsequentTransitPorts
      let isIpTransit = this.getProductType(product) === 'IP_TRANSIT'
      for (let i = 0; i < this.quote.products.length; i++) {
        let prod = this.quote.products[i]
        if (i === idx && isIpTransit) {
          deleteSubsequentTransitPorts = true
        } else if (
          deleteSubsequentTransitPorts &&
          this.getProductType(prod) !== 'IP_TRANSIT_PORT'
        ) {
          deleteSubsequentTransitPorts = false
        }
        if (
          i !== idx &&
          !(
            deleteSubsequentTransitPorts &&
            this.getProductType(prod) === 'IP_TRANSIT_PORT'
          )
        ) {
          newProducts.push(prod)
        }
      }
      this.quote.products = newProducts
      this.saveQuote()
    },

    cloneQuote() {
      this.quote.name = this.quote.name + ' (copy)'
      this.saveQuote(true, true)
    },

    cancel() {
      if (this.isNew) {
        this.$router.push('/quotes')
      } else {
        this.form.reset()
      }
    },

    getEmptyQuote() {
      // Provides data structure for the basis of any new quote. Note that some account & user
      // information will always be pre-populated from our current user object.
      let getters = this.$store.getters
      let user = this.$store.state.user.user
      return {
        name: '',
        group: GROUP,
        lookupGroup: GROUP,
        external: {
          atmos: {
            account: {
              _id: getters.getUserAccountID,
              name: getters.getUserAccountName
            },
            user: {
              _id: user.id,
              name: {
                first: user.first_name,
                last: user.last_name
              },
              email: user.email,
              phone: user.contact_number
            }
          }
        }
      }
    }
  }
}
